import PaymentManager_v2 from '../molecules/PaymentManager_v2';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import TwoColContainer from '../atoms/TwoColContainer';
import TwoColDetailRow from '../atoms/TwoColDetailRow';
import SectionBox from '../atoms/SectionBox';
import Divider from '@mui/material/Divider';
import config from '../../config';
import deleteStudent from '../../helpers/deleteStudent.helper';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';

const StudentDetailLayout_v2 = ({ studentDetail, refetch }) => {
  let btcert = undefined;
  let frcert = undefined;
  let hccert = undefined;
  let trcert = undefined;
  let paymentScreenshot = undefined;
  let paymentScreenshotYear = undefined;

  const currentYear = new Date().getFullYear();

  studentDetail?.documents?.forEach(doc => {
    let downloadLink;
    downloadLink = (
      <a
        href={`${config.DOCVIEWER}/${
          doc.document_name
        }?auth=${localStorage.getItem('token')}`}
        target='_blank'
      >
        Download
      </a>
    );

    if (doc.document_type === 'bt') btcert = downloadLink;
    if (doc.document_type === 'fr') frcert = downloadLink;
    if (doc.document_type === 'hc') hccert = downloadLink;
    if (doc.document_type === 'tr') trcert = downloadLink;
    if (doc.document_type === 'ps') {
      // Prefer the current year; otherwise take the latest we've seen.
      const docYear = Number(doc.document_year);
      if (
        !paymentScreenshot ||
        docYear === currentYear ||
        (paymentScreenshotYear !== currentYear &&
          docYear > (paymentScreenshotYear || 0))
      ) {
        paymentScreenshot = downloadLink;
        paymentScreenshotYear = docYear;
      }
    }
  });

  let primaryParent = {};
  let secondaryParent = {};
  studentDetail?.parents?.forEach(parent => {
    if (parent.parent_is_primary === 'YES') {
      primaryParent = {
        parentId: parent.parent_id,
        Name: parent.parent_name,
        ID: parent.parent_identity_number,
        Relationship: parent.parent_relationship,
        Mobile: parent.parent_mobile,
        Email: parent.parent_email,
        Religion: parent.parent_religion,
      };
    } else {
      secondaryParent = {
        parentId: parent.parent_id,
        Name: parent.parent_name,
        ID: parent.parent_identity_number,
        Relationship: parent.parent_relationship,
        Mobile: parent.parent_mobile,
        Email: parent.parent_email,
        Religion: parent.parent_religion,
      };
    }
  });

  let colorcode = '';
  if (studentDetail?.pref_session !== studentDetail?.session) {
    colorcode = 'text-red-500';
  }

  return (
    <div>
      {studentDetail?.student_session_time === '' && (
        <div className='mb-6 text-center text-xl font-bold text-red-700'>
          <Link to={`/manage/classes/${studentDetail?.student_level}`}>
            This student is not assigned to a session. CLICK HERE FIX IT!
          </Link>
        </div>
      )}

      {studentDetail?.student_notes === 'yes' && (
        <div className='text-center text-red-600'>
          This student has additional needs. Pls contact Parent for more info.
        </div>
      )}

      <div className='text-right text-xs'>
        Record created at{' '}
        {dayjs(studentDetail?.created_at).format('DD MMM YYYY HH:MM')} | &nbsp;
        {studentDetail?.student_photo_opt_in ? (
          <span className='text-green-800'>
            <CameraAltIcon />
          </span>
        ) : (
          <span className='text-red-800'>
            <NoPhotographyIcon />
          </span>
        )}
      </div>

      <SectionBox title='Payment Record' testid='payment-info-box'>
        {/* SectionBox is a 12 grid layout */}
        <div className='col-span-12'>
          <PaymentManager_v2
            student_id={studentDetail?.student_id}
            student_name={studentDetail?.student_bc_name}
            paymentMade={studentDetail?.payment}
            paymentHistory={studentDetail?.paymentHistory}
            refetch={refetch}
            fa={studentDetail?.student_fa}
          />
          {paymentScreenshot && (
            <div className='mt-4 text-sm' data-cy='payment-screenshot'>
              <span className='font-bold'>Payment Screenshot</span>
              {paymentScreenshotYear ? ` (${paymentScreenshotYear})` : ''}:{' '}
              {paymentScreenshot}
            </div>
          )}
        </div>
      </SectionBox>

      <SectionBox title='Basic Information' testid='basic-info-box'>
        <TwoColContainer>
          <TwoColDetailRow
            label='ID Number'
            value={`(${studentDetail?.student_id_type?.toUpperCase()}) ${
              studentDetail?.student_id_number
            } `}
          />
          <TwoColDetailRow
            label='First Name'
            value={studentDetail?.student_first_name}
          />
          <TwoColDetailRow
            label='Last Name'
            value={studentDetail?.student_last_name}
          />
          <TwoColDetailRow
            label='BC Name'
            value={studentDetail?.student_bc_name}
          />
          <TwoColDetailRow
            label='Date Of Birth'
            value={dayjs(studentDetail?.student_dob).format('DD MMMM YYYY')}
          />
          <TwoColDetailRow
            label='Address'
            value={`
            ${studentDetail?.student_address} ${studentDetail?.student_address_unit} ${studentDetail?.student_address_postal}`}
          />
          <TwoColDetailRow
            label='Mobile'
            value={studentDetail?.student_mobile}
          />
          <TwoColDetailRow
            label='Gender'
            value={studentDetail?.student_gender}
          />
        </TwoColContainer>
      </SectionBox>

      <SectionBox title='Session And School' testid='school-info-box'>
        <TwoColContainer>
          <TwoColDetailRow
            label='Transfer From'
            value={studentDetail?.student_transfer_from}
          />

          <TwoColDetailRow label='Transfer Document' value={trcert} />

          <TwoColDetailRow
            label='Cat Level'
            value={studentDetail?.student_level}
          />
          <TwoColDetailRow
            label='Preferred Session'
            value={studentDetail?.pref_session}
          />
          <TwoColDetailRow
            label='Cat Session'
            value={studentDetail?.session}
            className={colorcode}
          />
          <TwoColDetailRow
            label='School'
            value={studentDetail?.student_school}
          />
          <TwoColDetailRow
            label='School Level'
            value={studentDetail?.student_school_level}
          />
        </TwoColContainer>

        <div className=' my-4 py-4 text-sm'>
          <p className=' text-lg font-bold'>Movement Logs</p>
          <ul>
            {studentDetail?.logs?.map(logitem => {
              return (
                <li key={logitem.log_id} className=' list-inside list-disc'>
                  {dayjs(logitem?.created_at).format('DD MMM YY, HH:MM')}
                  {' - '}
                  {logitem.log_activity}
                </li>
              );
            })}
          </ul>
        </div>
      </SectionBox>

      <SectionBox title='Sacraments' testid='sacrament-info-box'>
        <TwoColContainer>
          {+studentDetail?.student_baptised === 0 && (
            <TwoColDetailRow label='Baptised' value='NO' />
          )}
          <TwoColDetailRow
            label='Baptism Date'
            value={
              studentDetail?.student_baptism_date
                ? dayjs(studentDetail?.student_baptism_date).format(
                    'DD MMMM YYYY'
                  )
                : undefined
            }
          />
          <TwoColDetailRow
            label='Baptism Church'
            value={studentDetail?.churches?.map(church => {
              if (
                Number(church.church_id) ===
                Number(studentDetail?.student_baptism_church)
              ) {
                return church.church_name;
              } else {
                return undefined;
              }
            })}
          />
          <TwoColDetailRow
            label='Baptism Church Overseas'
            value={studentDetail?.student_baptism_church_ovr || undefined}
          />
          <TwoColDetailRow label='Baptism Certificate' value={btcert} />

          <div className='col-span-12 my-4'>
            <Divider variant='middle' />
          </div>

          <TwoColDetailRow
            label='First Recon Date'
            value={
              studentDetail?.student_first_recon_date
                ? dayjs(studentDetail?.student_first_recon_date).format?.(
                    'DD MMMM YYYY'
                  )
                : undefined
            }
          />

          <TwoColDetailRow
            label='First Recon Church'
            value={
              studentDetail?.student_first_recon_church
                ? studentDetail?.churches?.map(church => {
                    if (
                      Number(church.church_id) ===
                      Number(studentDetail?.student_first_recon_church)
                    )
                      return church.church_name;
                    else return undefined;
                  })
                : undefined
            }
          />
          <TwoColDetailRow
            label='First Recon (Overseas)'
            value={studentDetail?.student_first_recon_church_ovr || undefined}
          />
          <TwoColDetailRow label='First Recon Certificate' value={frcert} />

          <div className='col-span-12 my-4'>
            <Divider variant='middle' />
          </div>

          <TwoColDetailRow
            label='First Holy Comm'
            value={
              studentDetail?.student_holy_comm_date
                ? dayjs(studentDetail?.student_holy_comm_date).format?.(
                    'DD MMMM YYYY'
                  )
                : undefined
            }
          />
          <TwoColDetailRow
            label='First Holy Comm Church'
            value={
              studentDetail?.student_holy_comm_church
                ? studentDetail?.churches?.map(church => {
                    if (
                      Number(church.church_id) ===
                      Number(studentDetail?.student_holy_comm_church)
                    )
                      return church.church_name;
                    else return undefined;
                  })
                : undefined
            }
          />
          <TwoColDetailRow
            label='Holy Comm Church Overseas'
            value={studentDetail?.student_holy_comm_church_ovr || undefined}
          />
          <TwoColDetailRow label='Holy Comm Certificate' value={hccert} />
        </TwoColContainer>
      </SectionBox>

      {/* SHOW EVENT ATTENDANCE INFORMATION */}
      {!!studentDetail?.attendance?.length && (
        <SectionBox title='Event Attendance' testid='event-info-box'>
          {studentDetail?.attendance?.map((event, index) => {
            return (
              <TwoColContainer key={index}>
                <TwoColDetailRow
                  label=<Link to={`/manage/events/${event.event_id}`}>
                    {event.event_title}
                  </Link>
                  value={dayjs(event.attendance_date).format('DD MMMM YYYY')}
                />
              </TwoColContainer>
            );
          })}
        </SectionBox>
      )}

      {studentDetail?.siblings?.length && (
        <SectionBox title='Siblings'>
          <TwoColContainer>
            {studentDetail?.siblings?.map((sibling, index) => {
              return (
                <TwoColDetailRow
                  key={index}
                  label={`Sibling ${index + 1}`}
                  value={`${sibling.student_first_name} ${sibling.student_last_name} (Level ${sibling.student_level}, ${sibling.session})`}
                  link={`/manage/students/${sibling.student_id}`}
                />
              );
            })}
          </TwoColContainer>
        </SectionBox>
      )}

      {/* STUDENT NOTES SECTION */}
      <SectionBox title='Student Notes'>
        <div className='whitespace-pre-wrap'>
          {studentDetail?.student_notes}
        </div>
      </SectionBox>

      <div className='grid md:grid-cols-2 md:gap-x-6'>
        <div>
          <SectionBox title='Primary Parent'>
            <div className='text-right'>
              <Link
                to={`/manage/parents/edit/${primaryParent.parentId}`}
                reloadDocument
                id='edit-primary-parent-link'
              >
                Edit Parent
              </Link>
            </div>
            {/* PRIMARY PARENT CONTAINER */}
            <TwoColContainer testid='primary-parent-container'>
              <TwoColDetailRow
                label='Parent Name'
                value={primaryParent.Name}
                testid='pri-parent'
              />
              <TwoColDetailRow
                label='ID'
                value={primaryParent.ID}
                testid='pri-parent-testid'
              />
              <TwoColDetailRow
                label='Relationship'
                value={primaryParent.Relationship}
              />
              <TwoColDetailRow
                label='Mobile'
                value={primaryParent.Mobile}
                testid='pri-parent-mobile'
              />
              <TwoColDetailRow
                label='Email'
                value={primaryParent.Email}
                testid='pri-parent-email'
              />
              <TwoColDetailRow
                label='Religion'
                value={primaryParent.Religion}
                testid='pri-parent-religion'
              />
            </TwoColContainer>
          </SectionBox>
        </div>

        <div>
          <SectionBox title='Secondary Parent'>
            <div className='text-right'>
              {secondaryParent?.parentId ? (
                <Link
                  to={`/manage/parents/edit/${secondaryParent.parentId}`}
                  reloadDocument
                  id='edit-sec-parent-link'
                >
                  Edit Parent
                </Link>
              ) : (
                <Link
                  to={`/manage/parents/add/${studentDetail?.student_id}`}
                  reloadDocument
                  id='add-sec-parent-link'
                >
                  Add Secondary
                </Link>
              )}
            </div>

            <TwoColContainer testid='secondary-parent-container'>
              <TwoColDetailRow
                label='Parent Name'
                value={secondaryParent?.Name}
              />
              <TwoColDetailRow label='ID' value={secondaryParent.ID} />
              <TwoColDetailRow
                label='Relationship'
                value={secondaryParent?.Relationship}
              />
              <TwoColDetailRow label='Mobile' value={secondaryParent?.Mobile} />
              <TwoColDetailRow label='Email' value={secondaryParent?.Email} />
              <TwoColDetailRow
                label='Religion'
                value={secondaryParent?.Religion}
              />
            </TwoColContainer>
          </SectionBox>
        </div>
      </div>
      <div className='text-center'>
        <button
          className='rounded-md border bg-red-600 p-4 font-bold text-white shadow-md'
          onClick={() => deleteStudent(studentDetail.student_id)}
        >
          Delete Student
        </button>
      </div>
    </div>
  );
};

export default StudentDetailLayout_v2;
